import React, { useMemo } from 'react';
import { App as AppAntd, Spin } from 'antd';
import { BrowserRouter as Router } from 'react-router-dom';
import { AuthContext } from './Context/Auth.context';
import { useAuth } from './Hooks/Auth.hook';
import { useRoutes } from './Routes/Routes';

function App() {
    const { token, login, logout, ready, userInfo } = useAuth();
    const isAuth = !!token;
    const router = useRoutes(isAuth, userInfo?.roles);
    const contextProviderValue = useMemo(
        () => ({
            token,
            login,
            logout,
            isAuth,
        }),
        [token, login, logout, isAuth]
    );
    if (!ready) {
        return (
            <div className="loadingPage">
                <Spin size="large" />
            </div>
        );
    }
    return (
        <AuthContext.Provider value={contextProviderValue}>
            <AppAntd>
                <Router>{router}</Router>
            </AppAntd>
        </AuthContext.Provider>
    );
}

export default App;
